import styled from "styled-components"
export const Wrapper = styled.div<{ footerState: boolean }>`
  display: ${({ footerState }) => (footerState ? "block" : "none")};

  width: 336px;
  height: 95px;
  padding: 15px;
  border-radius: 0 0 20px 20px;
  background: rgba(48, 30, 86, 0.85);

  section {
    display: flex;
    justify-content: center;
    border: 3px solid #ffb000;
    border-radius: 100px;
    padding: 15px 20px;
  }
  p {
    white-space: nowrap;
  }
`
